import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import React, {Component} from 'react';
import validator from "validator";
import {categories} from "../job-post/jobMenuOptions";

class AlertDialog extends Component {
	handleClose = () => {
		let {closeDialog} = this.props;
		if (closeDialog) {
			closeDialog();
		}
	};
	getMenu = () => {
		let menus = [];
		menus.push(<MenuItem value="-"><em>None</em></MenuItem>);
		categories.map((item, index) => {
			menus.push(<MenuItem value={item.value} key={index}>{item.text}</MenuItem>);
		});
		return menus;
	};
	onNameChanged = (e) => {
		let value = e.target.value;
		this.setState({
			name: value
		})
	};
	onEmailChanged = (e) => {
		let value = e.target.value;
		this.setState({
			email: value
		})
	};
	onCategoryChanged = (e) => {
		let value = e.target.value;
		this.setState({
			category: value
		})
	};
	handleSubmit = (e) => {
		e.preventDefault();
		let {name, email, category} = this.state;
		this.props.onSubmit(name, email, category);
	};

	constructor(props) {
		super(props);
		this.state = {
			open: true,
			name: "",
			email: "",
			category: ""
		};
	}

	render() {
		let {name, email, category} = this.state;
		return (
			<div>
				<Dialog
					open={this.state.open}
					onClose={this.handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description">
					<DialogTitle id="alert-dialog-title">{"Add new email in mailing list"}</DialogTitle>
					<form>
						<DialogContent>
							<TextField
								id="new-name"
								label="Name"
								required
								style={{width: "100%"}}
								value={name}
								onChange={this.onNameChanged}
								margin="normal"/>
							<TextField
								id="new-email"
								label="Email id"
								style={{width: "100%"}}
								required
								value={email}
								onChange={this.onEmailChanged}
								margin="normal"/>
							<FormControl style={{width: "100%"}}>
								<InputLabel htmlFor="category" required>Category</InputLabel>
								<Select
									value={category}
									style={{width: "100%"}}
									onChange={this.onCategoryChanged}
									inputProps={{
										name: 'category',
										id: 'category',
									}}>
									{this.getMenu()}
								</Select>
							</FormControl>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleClose} color="primary">
								Cancel
							</Button>
							<Button disabled={!(name && email.length && validator.isEmail(email))}
							        onClick={this.handleSubmit} color="primary" autoFocus>
								Submit
							</Button>
						</DialogActions>
					</form>
				</Dialog>
			</div>
		);
	}

}

export default AlertDialog;
